import PropTypes from 'prop-types'
import { useContext } from 'react'
import 'video.js/dist/video-js.css'
import * as SETTINGS from '../../../constants/settings'
import { SiteConfigContext } from '../../../context/siteConfigContext'
import './vjs-moal.css'

const StreamOffline = ({
  text = null,
  link = null,
  imageKey = null,
  withWrapper = false
}) => {
  const {
    [SETTINGS.STREAM_OFFLINE.key]: streamOffline,
    [SETTINGS.IMAGES.key]: images
  } = useContext(SiteConfigContext)

  const resolvedText = text ?? streamOffline?.text
  const resolvedLink = link === '' ? null : (link ?? streamOffline?.link)
  const resolvedImage = imageKey ? images[imageKey] : images.offline

  const handleLink = () => {
    if (resolvedLink) {
      window.open(resolvedLink, '_blank', 'noreferrer')
    }
  }

  const content = (
    <div
      onClick={handleLink}
      className={`m-auto flex flex-col justify-center items-center w-full ${
        resolvedLink ? 'cursor-pointer' : ''
      }`}
    >
      <div className="flex flex-col items-center my-auto w-full gap-4">
        <img
          className="mx-auto w-3/4 lg:w-3/5 xl:w-1/2 object-contain max-h-24 sm:max-h-32 md:max-h-40 lg:max-h-72 xl:max-h-96"
          src={resolvedImage}
          alt="Stream Offline"
        />
        <h3 className="text-center text-sm font-medium text-neutral-300 md:text-xl tracking-wide max-w-sm md:max-w-xl">
          {resolvedText}
        </h3>
      </div>
    </div>
  )

  return withWrapper ? (
    <div className="flex aspect-video bg-black">{content}</div>
  ) : (
    content
  )
}

StreamOffline.propTypes = {
  text: PropTypes.string,
  link: PropTypes.string,
  withWrapper: PropTypes.bool
}

export default StreamOffline
